<template>
    <ChartLine ref="chartInstance" :chartData="chartData" :chartOptions="chartOptions" :plugins="chartPlugins" style="height: 30vh;"/>
</template>
  
<script >

import { Line as ChartLine } from "vue-chartjs";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import chartjsPluginAnnotation from 'chartjs-plugin-annotation';
import * as helpers from '../helpers.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    chartjsPluginAnnotation,
);

export default {
    components: {
        ChartLine,
    },

    props:{
        id:String,
        precision:Number,
        mapType:String,
        selectedCarac:String,
        sextiles:Array,
        values:Array,
        minThreshold:Number,
        maxThreshold:Number,
        minXChart:Number,
        maxXChart:Number,
        maxOccur:Number,
        chartLinked:Boolean

    },

    data() {
        return {
            lang: navigator.language,
            element: null,
            clickedElement: null,
            lastEvent: null,
            startValue: null,
            endValue: null,
            startPixel: null,
            endPixel: null,
            minPixel: null,
            maxPixel: null,
        };
    },

    computed: {
        filteredValues() {
            let values = this.values.filter(v=> v !==null).map(v => v.toFixed(this.precision));
            if (this.selectedCarac === 'lwa') {
                if (this.mapType === "rawMap") {
                    values = values.map(v => 100*Math.floor(v/100))
                } else {
                    values = values.map(v => 10*Math.floor(v/10))
                }
            }
            return values
        },
        compteur () {
            const compteur = {};
            for (let val of this.filteredValues) {
                if (compteur[val]) {
                    compteur[val] += 1;
                } else {
                    compteur[val] = 1;
                }
            }
            return compteur
        },
        yvalPurcent () {
            return Object.values(this.compteur).map(v => v / this.filteredValues.length * 100)
        },
        chartData() {  
            // call sextiles to update chart colors 
            console.log('sextiles', this.sextiles)          
            return {
                labels: Object.keys(this.compteur),
                datasets: [
                    {
                        data: this.chartLinked ? this.yvalPurcent : this.yvalPurcent,
                        segment: {
                            borderColor: (ctx) => { return this.getColor(ctx.p1.parsed.x, this.sextiles) },
                        },
                        backgroundColor: 'black',
                    },
                ]
            }
        },

        chartOptions() {
            var self = this;
            
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        displayColors: false,
                        titleAlign: 'center',
                        bodyAlign: 'center'
                    },
                    annotation: {
                        enter(ctx) {
                            if (self.lastEvent == undefined)
                                self.element = ctx.element.options.id == 'line1' || ctx.element.options.id == 'line2' ? ctx.element : undefined;
                        },
                        leave(ctx) {
                            if (self.lastEvent != undefined)
                                return;
                            self.element = undefined;
                            self.lastEvent = undefined;
                        },
                        drawTime: "afterDraw",
                        annotations: {
                            line1: {
                                id: 'line1',
                                type: 'line',
                                //borderDash: [6, 6],
                                borderWidth: 2,
                                borderColor: "black",
                                //xMin: 0.15,
                                //xMax: 0.15,
                                //xScaleID: 'x',
                                //yScaleID: 'y',
                                scaleID:'x',
                                //backgroundColor: 'rgba(255, 99, 132, 0.25)',
                                label: {
                                    display: true,
                                    content: (ctx) => '[',
                                    position: 'center',
                                    font: {
                                    size: 12
                                    }
                                },
                                value: (ctx) => self.initMinValue(ctx) //this.minThreshold //
                            },
                            line2: {
                                id: 'line2',
                                type: 'line',
                                //borderDash: [6, 6],
                                borderWidth: 2,
                                borderColor: "black",
                                //xMin: 0.15,
                                //xMax: 0.15,
                                //xScaleID: 'x',
                                //yScaleID: 'y',
                                scaleID:'x',
                                //backgroundColor: 'rgba(255, 99, 132, 0)',
                                label: {
                                    display: true,
                                    content: (ctx) => ']', 
                                    position: 'center',
                                    font: {
                                    size: 12
                                    }
                                },
                                value: (ctx) => self.initMaxValue(ctx) // this.maxThreshold //
                            },
                            minThreshold: {
                                id: 'minThreshold',
                                type: 'line',
                                borderDash: [6, 6],
                                borderWidth: 1,
                                borderColor: "black",
                                scaleID:'x',
                                value: self.minThreshold
                            },
                            maxThreshold: {
                                id: 'maxThreshold',
                                type: 'line',
                                borderDash: [6, 6],
                                borderWidth: 1,
                                borderColor: "black",
                                scaleID:'x',
                                value: this.maxThreshold
                            }
                        }
                    },
                },
                pointRadius: 1,
                chartArea: {
                    backgroundColor: 'silver'
                },
                tension: 0.3,
                interaction: {
                    intersect: false,
                },
                locale: this.lang,
                events: ['mousedown', 'mouseup', 'mousemove', 'mouseout'],
                scales: {
                    x: {
                        type: 'linear',
                        min: (ctx) => { 
                             return this.chartLinked ? this.minXChart-(this.maxXChart-this.minXChart)/10 : console.log('min')
                            },
                        max: (ctx) => { 
                             return this.chartLinked ? this.maxXChart+(this.maxXChart-this.minXChart)/10 :  console.log('max')
                            },
                        //grace: '5%',
                        title: {
                            display: true,
                            text: this.$t(`caracs.${this.selectedCarac}.label`),
                            color: 'black'
                        },
                        ticks: {
                            color: 'black'
                        }
                    },
                    y : {
                        max: (ctx) => { 
                             return this.chartLinked ? Math.ceil(this.maxOccur) : console.log('max')
                            },
                        title: {
                            display: true,
                            text: this.$t(`chart.y.effectivePurcent`),
                            color: 'black'
                        },
                        ticks: {
                            color: 'black'
                        }
                    }
                },
            }
        },

        chartPlugins() {
            var self = this;

            const drag = function(moveX, moveY, chart) {
                if (self.element.options.id == 'line1')
                {
                    if (self.element.x < self.minPixel)
                        moveX = self.minPixel - self.element.x;
                    else if (self.element.x + 20 > self.endPixel)
                        moveX = self.endPixel - (self.element.x + 20);
                }
                else if (self.element.options.id == 'line2')
                {
                    if (self.element.x > self.maxPixel)
                        moveX = self.maxPixel - self.element.x;
                    else if (self.element.x - 20 < self.startPixel)
                        moveX = self.startPixel - (self.element.x - 20);
                }

                self.element.x += moveX;
                //self.element.y += moveY;
                self.element.x2 += moveX;
                //self.element.y2 += moveY;
                self.element.centerX += moveX;
                //self.element.centerY += moveY;
                if (self.element.elements && self.element.elements.length) {
                    for (const subEl of self.element.elements) {
                    subEl.x += moveX;
                    //subEl.y += moveY;
                    subEl.x2 += moveX;
                    //subEl.y2 += moveY;
                    subEl.centerX += moveX;
                    //subEl.centerY += moveY;
                    subEl.bX += moveX;
                    //subEl.bY += moveY;
                    }
                }
            };

            const handleElementDragging = function(chart, event) {
                if (!self.lastEvent || !self.element) {
                    return;
                }
                const moveX = event.x - self.lastEvent.x;
                const moveY = event.y - self.lastEvent.y;
                
                drag(moveX, moveY, chart);
                self.lastEvent = event;
                return true;
            };

            const setStartEndValues = function(chart) {
                if (self.clickedElement.options.id == 'line1')
                {
                    self.startValue = self.getXValueFromChart(chart, self.clickedElement.x);
                    self.startPixel = self.clickedElement.x;
                }  
                else if (self.clickedElement.options.id == 'line2')
                {
                    self.endValue = self.getXValueFromChart(chart, self.clickedElement.x);
                    self.endPixel = self.clickedElement.x;
                } 
            };

            const handleDrag = function(chart, event) {
                if (self.element && (self.element.options.id == "line1" || self.element.options.id == "line2")) {
                    switch (event.type) {
                    case 'mousemove':
                        return handleElementDragging(chart, event);
                    case 'mouseout':
                    case 'mouseup':
                        self.lastEvent = undefined;
                        setStartEndValues(chart)
                        self.clickedElement = undefined;
                        break;
                    case 'mousedown':
                        self.clickedElement = self.element;
                        self.lastEvent = event;
                        break;
                    default:
                    }
                }
            };

            return [
                {
                    id: 'dragger',
                    beforeEvent(chart, args) {
                        if (handleDrag(chart, args.event)) {
                            args.changed = true;
                            return;
                        }
                    }
                },
                {
                    id: 'customCanvasBackgroundColor',
                    beforeDraw: function (chart, easing) {
                        if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
                            const {ctx} = chart;
                            var chartArea = chart.chartArea;
                            ctx.save();
                            ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
                            ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
                            ctx.restore();
                        }
                    }
                }
            ]
        },
    },

    methods: {
        getColor(val, sextiles) { return helpers.getColor(val, sextiles)},

        getXValueFromChart(chart, x) {return chart.scales.x.getValueForPixel(x)},

        initMinValue(ctx) {
            // const labels = ctx.chart.data.labels.map(Number);
            // const val = Math.min(...labels);
            // this.startValue = this.minValue = val;
            this.startValue = this.minThreshold;
            this.startPixel = this.minPixel = ctx.chart.scales.x.getPixelForValue(this.startValue);
            // this.startPixel = ctx.chart.scales.x.getPixelForValue(this.minThreshold);
            return this.startValue;
        },

        initMaxValue(ctx) {
            // const labels = ctx.chart.data.labels.map(Number);
            // const val = Math.max(...labels);
            // this.endValue = this.maxValue = val;
            this.endValue = this.maxThreshold;
            this.endPixel = this.maxPixel = ctx.chart.scales.x.getPixelForValue(this.endValue);
            //this.endPixel = ctx.chart.scales.x.getPixelForValue(this.maxThreshold);
            return this.endValue;
        }
    },

    watch: {
        startValue : function(val){
            this.$emit('chartFilter', {id: this.id, start: this.startValue, end: this.endValue});
        },
        endValue : function(val){
            this.$emit('chartFilter', {id: this.id, start: this.startValue, end: this.endValue});
        }
    }
        
};
</script>
